<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'App',
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: 'RAND Configurator: Build your Rand Boat',
  },
  created() {
    window.addEventListener('resize', () => {
      this.onResize()
    })
  },
  computed: {
    ...mapState(['innerWidth']),
  },
  methods: {
    ...mapActions(['onResize']),
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/index.scss';
@import '../node_modules/bootstrap/scss/bootstrap';
@import '../node_modules/bootstrap-vue/src/index';

* {
  font-family: 'Lato', sans-serif;
  font-size: 16px;
}
</style>
